window.lazySizesConfig = window.lazySizesConfig || {};

import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes';

import scrollScout from './utils/scroll-scout';  // unnec. $ resize?

import header from './modules/header';
import accordion from './modules/accordion';
import lightbox from './modules/lightbox';

import featuerdPosts from './blocks/featured-posts';
import partners from './blocks/partners';
import eventsEmbed from './blocks/events-embed';

document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.className += ' dom-loaded';

  header.init();
  accordion.init();
  lightbox.init();

  featuerdPosts.init();
  partners.init();
  eventsEmbed.init();

  scrollScout.init();
});


